import React, { useEffect, useState } from "react";
// import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.css";
import { FormattedMessage } from "react-intl";
import { HotelImageGallerySlider } from "../../hotel-details/condo-image-slider/component";
// import './ImageGallery.css'; // Uncomment and use this line if you have custom CSS
// import './style.scss';
interface Image {
  description: string;
  draggable: boolean;
  height: number;
  url: string;
  width: number;
}

interface TransformedImage {
  href: string;
  type: string;
  source: string;
  width?: number;
}

interface ImageGalleryProps {
  images: Image[];
  hotelName: string;
}

const ImageGallery: React.FC<ImageGalleryProps> = ({ images, hotelName }) => {
  const uniqueImages = getUniqueImagesByDescription(images);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  const transformedImages:any = uniqueImages?.map((image:any) => ({
    href: image.url,
    type: "image",
    source: "local",
    width: image.width,
  }));

  function getUniqueImagesByDescription(images) {
    const uniqueImages = {};
    let addedThisLoop;

    do {
      addedThisLoop = false;
      for (const image of images) {
        const normalizedDescription = image.description.trim().toLowerCase();
        if (!uniqueImages[normalizedDescription]) {
          uniqueImages[normalizedDescription] = image;
          addedThisLoop = true;
        }
      }
    } while (addedThisLoop);

    return Object.values(uniqueImages);
  }

  const handleCancel = () => {
    setIsModalVisible(false);
  }
  const handleImageClick = (index: number) => {
    setIsModalVisible(true);
    setStartIndex(index);
  }
  return (
    <section className="card-grid pt-0">
      <div className="container">
        <div className="row g-2">
          {transformedImages?.length > 0 && (
            <div className="col-md-6 row-gutter">
              <span style={{cursor : 'pointer'}} onClick={() => handleImageClick(0)}>
                <div
                  className="card card-grid-lg card-element-hover card-overlay-hover overflow-hidden card-img-height"
                  style={{
                    backgroundImage: `url(${transformedImages[0].href})`,
                    backgroundPosition: 'center left',
                    backgroundSize: 'cover',
                  }}
                >
                  <div className="hover-element position-absolute w-100 h-100">
                    <i className="bi bi-fullscreen fs-6 text-white position-absolute top-50 start-50 translate-middle bg-dark rounded-1 p-2 lh-1"></i>
                  </div>
                </div>
              </span>
            </div>
          )}
                {images && <HotelImageGallerySlider
                  media={uniqueImages}
                  onCancel={handleCancel}
                  visible={isModalVisible}
                  title={hotelName}
                  startIndex={startIndex}
                  isVideoError={true}
                />}
          <div className="col-md-6 row-gutter">
            <div className="row g-2 row-gutter">
              {transformedImages?.slice(1, 2)?.map((image, index) => (
                <div className="col-12 row-gutter" key={`image-1-${index}`}>
                  <span style={{cursor : 'pointer'}} onClick={() => handleImageClick(index + 1)}>
                    <div
                      className="card card-grid-sm card-element-hover card-overlay-hover overflow-hidden"
                      style={{
                        backgroundImage: `url(${image.href})`,
                        backgroundPosition: "center left",
                        backgroundSize: "cover",
                      }}
                    >
                      <div className="hover-element position-absolute w-100 h-100">
                        <i className="bi bi-fullscreen fs-6 text-white position-absolute top-50 start-50 translate-middle bg-dark rounded-1 p-2 lh-1"></i>
                      </div>
                    </div>
                  </span>
                </div>
              ))}
              {transformedImages?.slice(2, 3)?.map((image, index) => (
                <div className="col-md-6 row-gutter" key={`image-2-${index}`}>
                  <span style={{cursor : 'pointer'}} onClick={() => handleImageClick(index + 2)}>
                    <div
                      className="card card-grid-sm card-element-hover card-overlay-hover overflow-hidden"
                      style={{
                        backgroundImage: `url(${image.href})`,
                        backgroundPosition: 'center left',
                        backgroundSize: 'cover',
                      }}
                    >
                      <div className="hover-element position-absolute w-100 h-100">
                        <i className="bi bi-fullscreen fs-6 text-white position-absolute top-50 start-50 translate-middle bg-dark rounded-1 p-2 lh-1"></i>
                      </div>
                    </div>
                  </span>
                </div>
              ))}
              {transformedImages?.slice(3, 4)?.map((image, index) => (
                <div className="col-md-6 row-gutter" key={`image-2-${index}`}>
                  <span style={{cursor : 'pointer'}} onClick={() => handleImageClick(index + 3)}>
                    <div
                      className="card card-grid-sm card-element-hover card-overlay-hover overflow-hidden"
                      style={{
                        backgroundImage: `url(${image.href})`,
                        backgroundPosition: 'center left',
                        backgroundSize: 'cover',
                      }}
                    >
                      <div className="hover-element position-absolute w-100 h-100">
                        <i className="bi bi-fullscreen fs-6 text-white position-absolute top-50 start-50 translate-middle bg-dark rounded-1 p-2 lh-1"></i>
                      </div>
                    </div>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImageGallery;
